import * as React from 'react';
import { Admin, CustomRoutes, Resource } from 'react-admin';
import { Route } from 'react-router-dom';
import { CustomLayout } from './layout/custom-layout';
import polyglotI18nProvider from 'ra-i18n-polyglot';
import { injectCustomMessages } from './custom-admin-messages';
import { authProvider } from './auth/authProvider';
import { AdminUserList } from './admin-user/admin-user-list';
import { AdminUserCreate } from './admin-user/admin-user-create';
import { customHungarianMessages } from './hungarian-messages';
import PasswordChangePage from './password-change/password-change-page';
import myDataProvider from './data-provider-with-image-convert';
import { brandingDarkTheme, brandingLightTheme } from './theme';
import { RequestList } from './request/request-list';
import { WebUserList } from './web-user/web-user-list';
import { WebUserShow } from './web-user/web-user-show';
import { DocumentCreate } from './document/document-create';
import { DocumentList } from './document/document-list';
import { DocumentEdit } from './document/document-edit';
import { AdminUserEdit } from './admin-user/admin-user-edit';
import { DocumentShow } from './document/document-show';
import {
    DocumentGroupCreate,
    DocumentGroupEdit,
} from './document-group/document-group-create-and-edit';
import { DocumentGroupList } from './document-group/document-group-list';
import { ParamsList } from './static-content/static-content-list';
import { ParamEdit } from './static-content/params-edit';
import { WebUserEdit } from './web-user/web-user-edit';
import { UniqueRequestList } from './unique-request/unique-request-list';
import { UniqueRequestShow } from './unique-request/unique-request-show';
import { UniqueRequestTemplateList } from './unique-request/template/unique-request-template-list';
import { UniqueRequestTemplateShow } from './unique-request/template/unique-request-template-show';
import {
    UniqueRequestTemplateCreate,
    UniqueRequestTemplateEdit,
} from './unique-request/template/unique-request-template-create-and-edit';

const messages = {
    hu: injectCustomMessages(customHungarianMessages),
};
const i18nProvider = polyglotI18nProvider(() => messages['hu'], 'hu');

const App = () => (
    <Admin
        dataProvider={myDataProvider}
        i18nProvider={i18nProvider}
        authProvider={authProvider}
        layout={CustomLayout}
        lightTheme={brandingLightTheme}
        darkTheme={brandingDarkTheme}
        defaultTheme={'light'}
    >
        <Resource
            name="document-group"
            list={DocumentGroupList}
            create={DocumentGroupCreate}
            edit={DocumentGroupEdit}
        />
        <Resource
            name="admin-user"
            list={AdminUserList}
            create={AdminUserCreate}
            edit={AdminUserEdit}
        />
        <Resource
            name="web-user"
            list={WebUserList}
            show={WebUserShow}
            edit={WebUserEdit}
        />
        <Resource
            name="document"
            list={DocumentList}
            create={DocumentCreate}
            edit={DocumentEdit}
            show={DocumentShow}
        />
        <Resource
            name="unique-request"
            list={UniqueRequestList}
            show={UniqueRequestShow}
        />
        <Resource
            name="request/_EInvoice"
            list={
                <RequestList
                    title={'Elektronikus számla igénylések'}
                    type={'EInvoice'}
                />
            }
        />
        <Resource
            name="unique-request-template"
            list={UniqueRequestTemplateList}
            show={UniqueRequestTemplateShow}
            create={UniqueRequestTemplateCreate}
            edit={UniqueRequestTemplateEdit}
        />
        <Resource name="static-content" list={ParamsList} edit={ParamEdit} />
        <CustomRoutes>
            <Route path="/password-change" element={<PasswordChangePage />} />
        </CustomRoutes>
    </Admin>
);

export default App;
